<template>
    <sign-in-form
        id="book-insighs-sign-in"
        form-class="primary"
        forgot-route="forgot-password"
        @submit-data="$_verifyAccountEmail"
    >
        <template v-slot:submit-btn-text>
            Connect With Email
        </template>
        <template v-slot:after-email-input>
            <slot name="sign-up-link">
                <p class="log-in-link">
                    Don't have an account?
                    <router-link replace :to="{ name: 'bi-sign-up', query: customQuery, params:{...$route.params}}">
                        Sign Up
                    </router-link>
                </p>
            </slot>
            <div class="or">
                <p>Or</p>
            </div>
            <facebook-auth @facebook-login="$_handleFacebookAuth">
                <template v-slot:default>
                    Connect With Facebook
                </template>
            </facebook-auth>
            <div class="terms-conditions">
                By continuing, you agree to the hibooks
                <router-link
                    class="text-primary"
                    :class="{ 'active' : $route.params.section == 'terms-and-conditions' }"
                    :to="{ name: 'book-insight-legal-term-of-service' }"
                    tabindex="-1"
                >
                    Terms
                </router-link> and
                <router-link
                    class="text-primary"
                    :class="{ 'active' : $route.params.section == 'terms-and-conditions' }"
                    :to="{ name: 'book-insight-legal-privacy-policy' }"
                    tabindex="-1"
                >
                    Privacy Policy.
                </router-link>
            </div>
        </template>
    </sign-in-form>
</template>

<script>
import SignIn from "@/mixins/signIn.js";

export default {
    name: "SignIn",
    components: {
        SignInForm: () => import(/* webpackChunkName: "sing-in-form"*/ "@c/auth/sign-in/form")
    },
    mixins: [SignIn],
    methods: {
        $_handleSuccessfullAuth(user = {}) {
            this.$emit("auth-sucessfull", user);
            this.$store.dispatch("User/setToken", user.token);
            Cookies.set("token", user.token);

            const defaultRouteToGo = { name: "bi-discover" };
            if (this.useRouteHandler) {
                this.$_handleNextRoute(this.$route, defaultRouteToGo);
            }
        }
    }
};
</script>
